import { render, staticRenderFns } from "./TransferWriteXA.vue?vue&type=template&id=322f0d6f&scoped=true"
import script from "./TransferWriteXA.vue?vue&type=script&lang=js"
export * from "./TransferWriteXA.vue?vue&type=script&lang=js"
import style0 from "./TransferWriteXA.vue?vue&type=style&index=0&id=322f0d6f&prod&lang=css"
import style1 from "./TransferWriteXA.vue?vue&type=style&index=1&id=322f0d6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f0d6f",
  null
  
)

export default component.exports